export default __webpack_public_path__ + "static/media/tennis-league-featured.22358859.png";